import React from 'react'

function Save() {
    return (
        <div>Save</div>
    )
}

export default React.memo(Save);